import { AnalyticsBrowser } from "@customerio/cdp-analytics-browser";
import { environment } from "../environment";

const isTactical = environment.VITE_ENV_TYPE === "tactical";
const writeKey = environment.VITE_CUSTOMER_IO_SDK_KEY;
const siteId = environment.VITE_CUSTOMER_IO_SITE_ID;

export const cioAnalytics =
  !isTactical && writeKey
    ? AnalyticsBrowser.load(
        { writeKey },
        siteId
          ? {
              integrations: {
                "Customer.io In-App Plugin": {
                  siteId,
                  colorScheme: "auto",
                },
              },
            }
          : undefined
      )
    : null;
